/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FufiFinancialInfoMoneyIn } from './FufiFinancialInfoMoneyIn';
import {
    FufiFinancialInfoMoneyInFromJSON,
    FufiFinancialInfoMoneyInFromJSONTyped,
    FufiFinancialInfoMoneyInToJSON,
    FufiFinancialInfoMoneyInToJSONTyped,
} from './FufiFinancialInfoMoneyIn';
import type { FufiFinancialInfoPremium } from './FufiFinancialInfoPremium';
import {
    FufiFinancialInfoPremiumFromJSON,
    FufiFinancialInfoPremiumFromJSONTyped,
    FufiFinancialInfoPremiumToJSON,
    FufiFinancialInfoPremiumToJSONTyped,
} from './FufiFinancialInfoPremium';

/**
 * 
 * @export
 * @interface FufiFinancialInfoResponse
 */
export interface FufiFinancialInfoResponse {
    /**
     * 
     * @type {Array<FufiFinancialInfoMoneyIn>}
     * @memberof FufiFinancialInfoResponse
     */
    moneyIns?: Array<FufiFinancialInfoMoneyIn> | null;
    /**
     * 
     * @type {Array<FufiFinancialInfoPremium>}
     * @memberof FufiFinancialInfoResponse
     */
    premiums?: Array<FufiFinancialInfoPremium> | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    moneyInsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    premiumsCount?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoResponse
     */
    effectDate: Date;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    contractNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    proposalNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoResponse
     */
    paidToDate: Date;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    debt: number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    totalWritten: number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    totalPaid: number;
}

/**
 * Check if a given object implements the FufiFinancialInfoResponse interface.
 */
export function instanceOfFufiFinancialInfoResponse(value: object): value is FufiFinancialInfoResponse {
    if (!('effectDate' in value) || value['effectDate'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('proposalNumber' in value) || value['proposalNumber'] === undefined) return false;
    if (!('paidToDate' in value) || value['paidToDate'] === undefined) return false;
    if (!('debt' in value) || value['debt'] === undefined) return false;
    if (!('totalWritten' in value) || value['totalWritten'] === undefined) return false;
    if (!('totalPaid' in value) || value['totalPaid'] === undefined) return false;
    return true;
}

export function FufiFinancialInfoResponseFromJSON(json: any): FufiFinancialInfoResponse {
    return FufiFinancialInfoResponseFromJSONTyped(json, false);
}

export function FufiFinancialInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'moneyIns': json['moneyIns'] == null ? undefined : ((json['moneyIns'] as Array<any>).map(FufiFinancialInfoMoneyInFromJSON)),
        'premiums': json['premiums'] == null ? undefined : ((json['premiums'] as Array<any>).map(FufiFinancialInfoPremiumFromJSON)),
        'moneyInsCount': json['moneyInsCount'] == null ? undefined : json['moneyInsCount'],
        'premiumsCount': json['premiumsCount'] == null ? undefined : json['premiumsCount'],
        'effectDate': (new Date(json['effectDate'])),
        'contractNumber': json['contractNumber'],
        'proposalNumber': json['proposalNumber'],
        'paidToDate': (new Date(json['paidToDate'])),
        'debt': json['debt'],
        'totalWritten': json['totalWritten'],
        'totalPaid': json['totalPaid'],
    };
}

export function FufiFinancialInfoResponseToJSON(json: any): FufiFinancialInfoResponse {
    return FufiFinancialInfoResponseToJSONTyped(json, false);
}

export function FufiFinancialInfoResponseToJSONTyped(value?: FufiFinancialInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'moneyIns': value['moneyIns'] == null ? undefined : ((value['moneyIns'] as Array<any>).map(FufiFinancialInfoMoneyInToJSON)),
        'premiums': value['premiums'] == null ? undefined : ((value['premiums'] as Array<any>).map(FufiFinancialInfoPremiumToJSON)),
        'moneyInsCount': value['moneyInsCount'],
        'premiumsCount': value['premiumsCount'],
        'effectDate': ((value['effectDate']).toISOString()),
        'contractNumber': value['contractNumber'],
        'proposalNumber': value['proposalNumber'],
        'paidToDate': ((value['paidToDate']).toISOString()),
        'debt': value['debt'],
        'totalWritten': value['totalWritten'],
        'totalPaid': value['totalPaid'],
    };
}

